<div class="reviews-outer">
  <h2 class="trinidad-bold">Become a caretaker for {{ (boondock$ | async)?.name }}.</h2>
  <p class="wizard-paragraph _12px">
    Caretakers provide information for the boondocking location. Caretakers can take control of any boondocking
    location.
  </p>
  <div class="w-form">
    <form [formGroup]="descriptionForm" id="email-form" name="email-form" data-name="Email Form">
      <div class="categories-description-outer">
        <div class="categories-categories-inner">
          <h4>
            Location description
            <span class="fine-print trinidad">(Optional)</span>
          </h4>
          <textarea
            placeholder="Type a description the site and what is located on or near this location..."
            maxlength="5000"
            id="description"
            name="description"
            formControlName="description"
            class="site-description w-input"
          ></textarea>
          <h4>Resource URL <span class="fine-print trinidad">(Optional)</span></h4>
          <input
            type="text"
            maxlength="256"
            id="resource-url"
            placeholder="Type a website that provides additional information..."
            formControlName="resourceUrl"
            class="text-input w-input"
          />
        </div>
      </div>
      <div class="horz-line _18px"></div>
      <h4>Upload photos <span class="fine-print trinidad">(Recommended)</span></h4>
      <curbnturf-review-photos [listingForm]="descriptionForm" [boondock]="boondock$ | async"> </curbnturf-review-photos>
    </form>
  </div>
  <div class="button-wrapper">
    <a role="button" class="button trinidad center w-button" (click)="onContinue()"> Continue </a>
  </div>
  <div class="skip" *ngIf="!appContext">
    <a role="button" (click)="onSkip()">Skip</a>
  </div>
</div>
